import { useBooleanFlagValue } from "@openfeature/react-sdk";

import type { Locale } from "@av/components/organisms/type";

export type LanguageOption = {
  value: Locale;
  label: string;
};

export const supportedLanguages: LanguageOption[] = [
  { value: "en-CA", label: "English (CA)" },
  { value: "fr-CA", label: "Français (CA)" },
];

export const demoLanguages: LanguageOption[] = [
  { value: "es", label: "Español" },
  { value: "jp", label: "日本語" },
];

export function useSupportedLanguages() {
  const isDemoLanguagesSupported = useBooleanFlagValue("demo_language", false);

  if (isDemoLanguagesSupported) return supportedLanguages.concat(demoLanguages);

  return supportedLanguages;
}

export function useHardcodedLanguages() {
  return supportedLanguages;
}
